import React, { useState } from 'react';
import PropTypes from 'prop-types';
import { Card, CardBody, CardTitle, ButtonDropdown, DropdownItem, DropdownMenu, DropdownToggle } from 'reactstrap';
import { Line } from 'react-chartjs-2';
import { isEmpty } from 'lodash';
import { CustomTooltips } from '@coreui/coreui-plugin-chartjs-custom-tooltips';
import { drawLine as drawLinePlugin } from './plugins';

LineChart.propTypes = {
    heading: PropTypes.string,
    labels: PropTypes.array,
    label: PropTypes.string,
    data: PropTypes.array,
    color: PropTypes.string,
    label2: PropTypes.string,
    data2: PropTypes.array,
    fill2: PropTypes.bool,
    color2: PropTypes.string,
    xLabel: PropTypes.string,
    yLabel: PropTypes.string,
    heigth: PropTypes.number,
    fill: PropTypes.bool,
    legend: PropTypes.bool,
    showFilter: PropTypes.bool,
    showInfoIcon: PropTypes.bool,
    drawLine: PropTypes.object,
    changeFilter: PropTypes.func,
}

LineChart.defaultProps = {
    heading: '',
    labels: [],
    label: '',
    data: [],
    color: '',
    label2: '',
    data2: [],
    fill2: false,
    color2: '',
    xLabel: '',
    yLabel: '',
    heigth: 270,
    fill: false,
    legend: true,
    showFilter: false,
    showInfoIcon: false,
    drawLine: null,
    // changeFilter:''
    // drawLine: {
    //     text: '',
    //     pointIndex: -1
    // },
};

function LineChart(props) {
    console.log(props);
    const [isOpen, setIsOpen] = useState(false);
    // const [] = useState();

    const data = {
        labels: props.labels,
        datasets: [{
            label: props.label,
            fill: props.fill,
            lineTension: 0.1,
            backgroundColor: props.color || 'rgba(75,192,192,0.4)',
            borderColor: props.color || 'rgba(75,192,192,1)',
            borderCapStyle: 'butt',
            borderDash: [],
            borderDashOffset: 0.0,
            borderJoinStyle: 'miter',
            pointBorderColor: props.color || 'rgba(75,192,192,1)',
            pointBackgroundColor: '#fff',
            pointBorderWidth: 1,
            pointHoverRadius: 5,
            pointHoverBackgroundColor: props.color || 'rgba(75,192,192,1)',
            pointHoverBorderColor: props.color || 'rgba(220,220,220,1)',
            pointHoverBorderWidth: 2,
            pointRadius: 1,
            pointHitRadius: 10,
            data: props.data,
        }, {
            label: props.label2,
            fill: props.fill2,
            lineTension: 0.1,
            backgroundColor: props.color2 || '#4dbd74',
            borderColor: props.color2 || '#4dbd74',
            borderCapStyle: 'butt',
            borderDash: [],
            borderDashOffset: 0.0,
            borderJoinStyle: 'miter',
            pointBorderColor: props.color2 || '#4dbd74',
            pointBackgroundColor: '#fff',
            pointBorderWidth: 1,
            pointHoverRadius: 5,
            pointHoverBackgroundColor: props.color2 || '#4dbd74',
            pointHoverBorderColor: props.color2 || '#4dbd74',
            pointHoverBorderWidth: 2,
            pointRadius: 1,
            pointHitRadius: 10,
            data: props.data2,
        }],
    };

    function changeFilterData(e){
        setIsOpen(!isOpen);
        console.log(e.target);
        console.log(e.target.name);
        console.log(e.target.value);
        console.log(props);
        let value = e.target.value

        if(value!== "" && value!== undefined){
            props.changeFilter(value)
        }
    } 

    const options = {
        tooltips: {
            enabled: false,
            custom: CustomTooltips,
        },
        legend: {
            "display": props.legend,
        },
        maintainAspectRatio: false,
        scales: {
            yAxes: [{
                scaleLabel: {
                    display: !!props.yLabel,
                    labelString: props.yLabel
                }
            }],
            xAxes: [{
                scaleLabel: {
                    display: !!props.xLabel,
                    labelString: props.xLabel
                }
            }],
        },
    }

    const plugins = [];

    if (!isEmpty(props.drawLine)) {
        console.log(props.drawLine);
        plugins.push({
            afterDraw: drawLinePlugin(props.drawLine),
        });
    }

    const filters = (
        <div className="pull-right">
            <ButtonDropdown className="filterdropdown"
             isOpen={isOpen} 
            //  onSelect={changeFilter} 
             toggle={(e) =>
                changeFilterData(e)
                //  { setIsOpen(!isOpen) }
            }
             >
                <DropdownToggle>
                    <i className="cursor-pointer-d h4 fa fa-filter" aria-hidden="true"></i>
                    {props.filterValue}
                </DropdownToggle>
                <DropdownMenu right>
                    <DropdownItem value='day'>Daily</DropdownItem>
                    <DropdownItem value='week'>Weekly</DropdownItem>
                    <DropdownItem value='month'>Monthly</DropdownItem>
                </DropdownMenu>
            </ButtonDropdown>
        </div>
    );

    return (
        <Card>
            <CardBody>
                {props.showFilter && filters}
                <CardTitle className="mb-2">
                    {props.heading}
                    {props.showInfoIcon &&
                        <i style={{ 'fontSize': '22px', 'position': 'absolute' }} className="ml-2 fa fa-info cursor-pointer" />
                    }
                </CardTitle>
                <div className="clearfix"></div>
                <div className="chart-wrapper">
                    <Line data={data} options={options} height={props.height} plugins={plugins} />
                </div>
            </CardBody>
        </Card>
    )
}

export default LineChart;

